var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReviewCard',{attrs:{"review":_vm.review,"listing-id":_vm.listingId,"profile":"business","can-edit":""},on:{"open-edit-modal":_vm.openEditModal,"open-report-modal":_vm.openReportModal,"open-delete-modal":_vm.openDeleteModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }